import { jsx as _jsx } from "react/jsx-runtime";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
const RUNNING_PROMPTS_SEPARATOR = "|";
export const convertToMagicTag = (tag, tagIndex)=>({
        [`tag${tagIndex + 1}Text`]: tag.tagText,
        [`tag${tagIndex + 1}Prompt`]: tag.tagPrompt,
        [`tag${tagIndex + 1}Visibility`]: true
    });
export const wrapTextInMarkupLanguage = (text)=>text ? /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
        text: text
    }) : undefined;
export const getRunningPromptsText = (runningPrompts)=>{
    if (!runningPrompts || !Array.isArray(runningPrompts)) {
        return "";
    }
    return runningPrompts.map((prompt)=>prompt.text).join(RUNNING_PROMPTS_SEPARATOR);
};
